import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';

export const useCruxStore = defineStore('crux-version', () => {
  const {
    items: cruxVersions,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroyItem: destroy,
  } = createBaseStore('api/assets/crux-version');

  return {
    cruxVersions,
    fetch,
    destroy,
    update,
    store,
  };
});
